import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['100h/year planning from scratch', '10 min/week. Everything ready.'], ['Improvised lessons with no progression', '120+ drills + 6 volumes by level'], ['Students improving slowly', 'Logical, measurable progression'], ['Parents asking for results', 'Evaluation sheets and progress tracking'], ['Walking in unprepared', 'Every session planned and ready to run']];
export function FinalCTA() {
  return <section className="border-y-4 border-emerald-400 bg-[#09281d] px-5 py-20" data-id="element-36" data-mp="vv9p9i0hfhn0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-37" data-mp="qvopx6heh79r">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-38" data-mp="qwzwfe28ct4k">
          Stop improvising.{' '}
          <span className="text-emerald-300" data-id="element-39" data-mp="14t3i2iz1ft5f">
            Start teaching with a system.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-slate-300" data-id="element-40" data-mp="2c4wo4ojgcche">
          Join hundreds of PE teachers worldwide who already plan their entire
          school year in under 5 minutes.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[.18em] text-emerald-200" data-id="element-41" data-mp="2m2kru3z1cubp">
          Sessions · Drills · Progressions · Assessment · All organized
        </p>
        <div className="mt-10 overflow-hidden border border-emerald-300/30 text-left" data-id="element-42" data-mp="2v3setpw3q8qh">
          <div className="grid grid-cols-2 bg-[#10372a] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-43" data-mp="302lvtsalkhve">
            <p className="p-4 text-slate-300" data-id="element-44" data-mp="34ssi3lhmzqah">Without P.E. READY 360</p>
            <p className="border-l border-emerald-300/30 p-4 text-emerald-300" data-id="element-45" data-mp="34vohle94un11">
              With P.E. READY 360
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-emerald-300/20 text-xs sm:text-sm" data-id="element-46" data-mp="3epoqzsbg6efk">
              <p className="flex gap-2 p-4 font-medium text-slate-300" data-id="element-47" data-mp="1jpel5gs2tcum">
                <span className="text-red-400" data-id="element-48" data-mp="1eps9hbrwc4nx">×</span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-emerald-300/20 bg-emerald-300/5 p-4 font-semibold text-white" data-id="element-49" data-mp="1sh6shilt05uz">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-300" data-id="element-50" data-mp="1novsyguz6m2y" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-51" data-mp="1xg075ectu2wq">
          <CountdownTimer dark data-id="element-52" data-mp="1xeot8lpo3erw" />
        </div>
        <div className="border-2 border-emerald-400 bg-[#10372a] p-7 text-left" data-id="element-53" data-mp="1xi48ppn96ptu">
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-54" data-mp="2beq32qnwtwji">
            Complete package
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-55" data-mp="h1i6atgdjav8">
            P.E. READY 360™ — 6 Volumes + 5 Bonuses
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-56" data-mp="d0ois16ufy2v">
            <div data-id="element-57" data-mp="2vyazeordzqq">
              <p className="text-sm font-bold text-slate-300 line-through" data-id="element-58" data-mp="2vg5rsk4cb6o">
                $90
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-59" data-mp="6xtcokalqf51">
                $27
              </p>
            </div>
            <p className="bg-emerald-400 px-3 py-2 text-xs font-bold uppercase text-[#09281d]" data-id="element-60" data-mp="3pbap3se9z45u">
              Save $63
            </p>
          </div>
        </div>
        <a href="https://p-e-ready.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-61" data-mp="3fcbomx3nyetx">
          YES, I WANT MY PE BIBLE
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-62" data-mp="36ej7roiamz4f">
          <span className="flex gap-1" data-id="element-63" data-mp="3bdvvsckwic8l">
            <LockKeyholeIcon className="h-4 w-4 text-emerald-300" data-id="element-64" data-mp="14ks86rpk5h1c" /> Secure
            payment
          </span>
          <span className="flex gap-1" data-id="element-65" data-mp="19jdcp3buemvl">
            <ZapIcon className="h-4 w-4 text-emerald-300" data-id="element-66" data-mp="19ic02uf6hsbr" /> Instant access
          </span>
          <span className="flex gap-1" data-id="element-67" data-mp="35mrsy389h49q">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-300" data-id="element-68" data-mp="30oq22w4lg0np" /> 7-day
            guarantee
          </span>
        </div>
      </div>
    </section>;
}